module.exports = __webpack_public_path__ + "img/Frame-93.92e4d090.svg";